import { makeBetterEnum } from './betterEnum';

export const BiChartKind = makeBetterEnum(
  'BarHorizontal',
  'BarVertical',
  'TimeSeries',
  'Pie',
  'Treemap',
  'Meter',
  'BigNumber',
  'Pareto'
);

export type BiChartKind = (typeof BiChartKind)[keyof typeof BiChartKind];

export const BiChartKindGroup = makeBetterEnum('Bar', 'Percentage', 'Other');

export type BiChartKindGroup =
  (typeof BiChartKindGroup)[keyof typeof BiChartKindGroup];

export const BiSavedViewCustomReportDisplayKind = makeBetterEnum(
  'Table',
  'Chart',
  'Both'
);

export type BiSavedViewCustomReportDisplayKind =
  (typeof BiSavedViewCustomReportDisplayKind)[keyof typeof BiSavedViewCustomReportDisplayKind];

export const BiFilterOperator = makeBetterEnum(
  'In',
  'NotIn',
  'Empty',
  'NotEmpty',
  'Equal',
  'NotEqual',
  'LessThan',
  'LessThanOrEqual',
  'GreaterThan',
  'GreaterThanOrEqual',
  'Contains', // case-insensitive; string contains single string
  'DoesNotContain' // case-insensitive; string does not contain single string
);

export type BiFilterOperator =
  (typeof BiFilterOperator)[keyof typeof BiFilterOperator];

export const BiQueryMode = makeBetterEnum(
  'Activity',
  'Snapshot',
  'FinanceFootprintSnapshot',
  'Lineage',
  'ReferenceData',
  'ProductFootprint',
  'MaterialMaster'
);

export type BiQueryMode = (typeof BiQueryMode)[keyof typeof BiQueryMode];

export const BiDisplayMappingType = {
  AgeGroup: 'ageGroup',
  ApprovalStatus: 'approvalStatus',
  AreaUnit: 'areaUnit',
  AssetHoldingCategory: 'assetHoldingCategory',
  BeaCode: 'beaCode',
  BuildingLeaseType: 'buildingLeaseType',
  BusinessActivityType: 'businessActivityType',
  CasNumber: 'casNumber',
  CategoryId: 'categoryId',
  CleanPowerContractualInstrument: 'cleanPowerContractualInstrument',
  ContributionKind: 'contributionKind',
  DataOwners: 'dataOwners', // deprecated: dataOwners was removed from BI due to performance reasons
  DatasetId: 'datasetId',
  DistanceMethod: 'distanceMethod',
  DryMethod: 'dryMethod',
  EmployeeGroupType: 'employeeGroupType',
  EmploymentType: 'employmentType',
  EuPollutantGroup: 'euPollutantGroup',
  FileIds: 'fileIds',
  FinanceAssetHoldingClass: 'financeAssetHoldingClass',
  FlightCabinClass: 'flightCabinClass',
  GenderLabels: 'genderLabels',
  GhgCategoryId: 'ghgCategoryId',
  GhgRemovalActivity: 'ghgRemovalActivity',
  GhgRemovalScope: 'ghgRemovalScope',
  GhgRemovalStoragePool: 'ghgRemovalStoragePool',
  HealthAndSafetyEmployeeType: 'healthAndSafetyEmployeeType',
  IncidentType: 'incidentType',
  IndustryCode: 'industryCode',
  LobbyingExpenseKind: 'lobbyingExpenseKind',
  LocationCountry: 'locationCountry',
  LogisticsPosition: 'logisticsPosition',
  LulucfCategory: 'lulucfCategory',
  MeasurementProjectIds: 'measurementProjectIds',
  Natura2000SiteNames: 'natura2000SiteNames',
  NonEmployeeType: 'nonEmployeeType',
  OrgUnit: 'orgUnit',
  OwnWorkforceType: 'ownWorkforceType',
  PollutantSubstanceOfConcern: 'pollutantSubstanceOfConcern',
  PollutantSubstanceOfConcernHazardClass:
    'pollutantSubstanceOfConcernHazardClass',
  ReleaseId: 'releaseId',
  SbtCommitmentStage: 'sbtCommitmentStage',
  SubstanceInflowMedium: 'substanceInflowMedium',
  SubstanceOutflowMedium: 'substanceOutflowMedium',
  TransportationMode: 'transportationMode',
  TripKind: 'tripKind',
  UncollapsedCompanyId: 'uncollapsedCompanyId',
  Unit: 'unit',
  UploaderIds: 'uploaderIds',
  VehicleType: 'vehicleType',
  VehicleUsageReason: 'vehicleUsageReason',
  WashMethod: 'washMethod',
  WasteTreatment: 'wasteTreatment',
  PcfCreationSource: 'pcfCreationSource',
} as const;

export type BiDisplayMappingType =
  (typeof BiDisplayMappingType)[keyof typeof BiDisplayMappingType];

export const PermissionReferenceType = makeBetterEnum(
  'FootprintSnapshot',
  'ExtBart'
);

export const EmptyStringType = makeBetterEnum(
  'Emdash',
  'Empty',
  'UnspecifiedWithDisplayName'
);

export type EmptyStringType =
  (typeof EmptyStringType)[keyof typeof EmptyStringType];

export const BiSavedViewVisibility = makeBetterEnum('Private', 'Org');

export type BiSavedViewVisibility =
  (typeof BiSavedViewVisibility)[keyof typeof BiSavedViewVisibility];

export const BiQueryOrderDirection = makeBetterEnum('Asc', 'Desc');

export type BiQueryOrderDirection =
  (typeof BiQueryOrderDirection)[keyof typeof BiQueryOrderDirection];
